import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Select from '../../form/Select'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import Input from '../../form/Input'

const DerivedChartModal = ({ store }) => (
    <Modal
        show={store.derivedChartModalOpen}
        onClose={store.handleCloseDerivedChartModal}
    >
        <Typography type="h2">Derived importance</Typography>

        <br />

        <Select
            label="Select Question"
            options={store.derivedQuestions
                .map((q) => ({ label: store.getTitle(q.question), value: q.question.id }))}
            onBlur={(e) => store.handleDerivedSelection(e.value, 'question')}
            defaultValue={store.derivedChartModalSelections.question}
        />

        <br />

        <Select
            label="Select KPI"
            options={store.derivedKpiQuestions
                .map((q) => ({ label: store.getTitle(q.question), value: q.question.id }))}
            onBlur={(e) => store.handleDerivedSelection(e.value, 'kpi')}
            defaultValue={store.derivedChartModalSelections.kpi}
        />

        <br />

        <Input
            type="number"
            label="Remove base sizes under"
            defaultValue={store.derivedChartModalSelections.base}
            onBlur={(e) => store.handleDerivedSelection(e.value, 'base')}
        />

        <ModalFooter>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                    label={i18n.t('cancel')}
                    onClick={store.handleCloseDerivedChartModal}
                    cssClass="regular tertiary"
                />

                <Button
                    label="Create slide"
                    onClick={store.handleAddDerivedSlide}
                    cssClass="regular primary"
                />
            </div>
        </ModalFooter>
    </Modal>
)

export default observer(DerivedChartModal)
